import { i18n } from "../src/plugins/i18n";

const content = {
  page_title: "Devices",
  battery_status: {
    title: i18n.t("views.Assets.charts.batteryStatus.title"),
    tooltip: i18n.t("views.Assets.charts.batteryStatus.tooltip"),
    header: [
      i18n.t("views.Assets.charts.batteryStatus.header.batteryStatus"),
      i18n.t("views.Assets.charts.batteryStatus.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.batteryStatus.data.highBattery.label"),
        value: "High",
        msg: i18n.t("views.Assets.charts.batteryStatus.data.highBattery.message"),
      },
      {
        label: i18n.t("views.Assets.charts.batteryStatus.data.lowBattery.label"),
        value: "Low",
        msg: i18n.t("views.Assets.charts.batteryStatus.data.lowBattery.message"),
      },
      {
        label: i18n.t("views.Assets.charts.batteryStatus.data.unknownBattery.label"),
        value: "No data",
        msg: i18n.t("views.Assets.charts.batteryStatus.data.unknownBattery.message"),
      },
    ],
  },
  connection_status: {
    title: i18n.t("views.Assets.charts.devicesCommunication.title"),
    tooltip: i18n.t("views.Assets.charts.devicesCommunication.tooltip"),
    header: [
      i18n.t("views.Assets.charts.devicesCommunication.header.connectivity"),
      i18n.t("views.Assets.charts.devicesCommunication.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.devicesCommunication.data.communicated.label"),
        value: "FullConnection",
        msg: i18n.t("views.Assets.charts.devicesCommunication.data.communicated.message"),
      },
      {
        label: i18n.t("views.Assets.charts.devicesCommunication.data.noCommunications.label"),
        value: "NotConnection",
        msg: i18n.t("views.Assets.charts.devicesCommunication.data.noCommunications.message"),
      },
      {
        label: i18n.t("views.Assets.charts.devicesCommunication.data.missedMessages.label"),
        value: "PoorConnection",
        msg: i18n.t("views.Assets.charts.devicesCommunication.data.missedMessages.message"),
      },
    ],
  },
  device_status: {
    title: i18n.t("views.Assets.charts.devicesStatus.title"),
    tooltip: i18n.t("views.Assets.charts.devicesStatus.tooltip"),
    header: [
      i18n.t("views.Assets.charts.devicesStatus.header.deviceStatus"),
      i18n.t("views.Assets.charts.devicesStatus.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.noIssue.label"),
        value: "NoProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.noIssue.message"),
        fields: ["FlagsBin"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.phaseImbalance.label"),
        value: "HasImbalanceProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.phaseImbalance.message"),
        fields: ["HasImbalance"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.temperatureAlert.label"),
        value: "HasTempProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.temperatureAlert.message"),
        fields: ["HasTemperatureOutsideRangeProblem", "HasTempSenseProblem", "HasTempOverLimitProblem"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.currentOverlimit.label"),
        value: "HasCurrentOverlimitProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.currentOverlimit.message"),
        fields: ["HasCurrentOverlimitProblem"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.communicationProblem.label"),
        value: "HasCommsProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.communicationProblem.message"),
        fields: ["MessagesMissed"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.noPower.label"),
        value: "HasPowerProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.noPower.message"),
        fields: ["HasNoPower"],
      },
      {
        label: i18n.t("views.Assets.charts.devicesStatus.data.lowBattery.label"),
        value: "HasBatteryProblem",
        msg: i18n.t("views.Assets.charts.devicesStatus.data.lowBattery.message"),
        fields: ["HasLowBattery"],
      },
    ],
  },
  imbalance_problems: {
    title: i18n.t("views.Assets.charts.imbalance.title"),
    tooltip: i18n.t("views.Assets.charts.imbalance.tooltip"),
    header: [
      i18n.t("views.Assets.charts.imbalance.header.imbalanceStatus"),
      i18n.t("views.Assets.charts.imbalance.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.imbalance.data.normal.label"),
        value: "TotalNormalBalance",
        msg: i18n.t("views.Assets.charts.imbalance.data.normal.message"),
      },
      {
        label: i18n.t("views.Assets.charts.imbalance.data.imbalance.label"),
        value: "TotalWithImbalance",
        msg: i18n.t("views.Assets.charts.imbalance.data.imbalance.message"),
      },
    ],
  },
  power_change_problems: {
    title: i18n.t("views.Assets.charts.powerChange.title"),
    tooltip: i18n.t("views.Assets.charts.powerChange.tooltip"),
    header: [
      i18n.t("views.Assets.charts.powerChange.header.powerChangeStatus"),
      i18n.t("views.Assets.charts.powerChange.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.powerChange.data.normal.label"),
        value: "TotalNormalBalance",
        msg: i18n.t("views.Assets.charts.powerChange.data.normal.message"),
      },
      {
        label: i18n.t("views.Assets.charts.powerChange.data.abnormal.label"),
        value: "TotalAbnormalPowerChange",
        msg: i18n.t("views.Assets.charts.powerChange.data.abnormal.message"),
      },
    ],
  },
  capacity_problems: {
    title: i18n.t("views.Assets.charts.capacity.title"),
    tooltip: i18n.t("views.Assets.charts.capacity.tooltip"),
    header: [
      i18n.t("views.Assets.charts.capacity.header.capacity"),
      i18n.t("views.Assets.charts.capacity.header.numberOfDevices"),
      {
        role: "tooltip",
        type: "string",
        p: {
          html: true,
        },
      },
    ],
    data: [
      {
        label: i18n.t("views.Assets.charts.capacity.data.underperforming.text"),
        value: "TotalUnderperforming",
        msg: i18n.t("views.Assets.charts.capacity.data.underperforming.message"),
      },
      {
        label: i18n.t("views.Assets.charts.capacity.data.normal.text"),
        value: "TotalNormal",
        msg: i18n.t("views.Assets.charts.capacity.data.normal.message"),
      },
      {
        label: i18n.t("views.Assets.charts.capacity.data.overutilised.text"),
        value: "TotalOverUtilised",
        msg: i18n.t("views.Assets.charts.capacity.data.overutilised.message"),
      },
    ],
  },
  devices_overview_select: [
    {
      label: i18n.t("common.times.time.today"),
      value: "1",
    },
    {
      label: i18n.t("common.words.this") + " " + i18n.t("common.times.time.week"),
      value: "7",
    },
    {
      label: i18n.t("common.words.this") + " " + i18n.t("common.times.time.month"),
      value: "30",
    },
  ],
  filters: {
    primary: [
      {
        value: "All",
        label: i18n.t("common.words.all"),
      },
      {
        value: "Watchlist",
        label: i18n.t("common.words.watchList"),
      },
    ],

    secondary: {
      list_checkbox: [
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.list_checkbox.label"),
          value: "DeviceType",
          values: ["ROG1PHASE", "ROG3PHASE"],
        },
      ],
      flags: [
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.flags.temperatureOverlimit.label"),
          value: "TemperatureOverLimit",
        },
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.flags.currentOverlimit.label"),
          value: "CurrentOverLimit",
        },
      ],
      range: [
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.range.transformerSize.label"),
          min: 0,
          max: 200,
          value: "PowerRating",
        },
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.range.maxCurrentPH1.label"),
          min: 0,
          max: 5000,
          value: "Current0Max",
        },
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.range.maxCurrentPH2.label"),
          min: 0,
          max: 5000,
          value: "Current1Max",
        },
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.range.maxCurrentPH3.label"),
          min: 0,
          max: 5000,
          value: "Current2Max",
        },
        {
          label: i18n.t("views.Assets.tables.devices.filters.secondary.range.maxTemperature.label"),
          min: 0,
          max: 200,
          value: "TemperatureMax",
        },
      ],
    },
  },
  device_details: [
    {
      label: i18n.t("views.Asset.deviceDetails.transformerNo.label"),
      value: "SerialNumber",
    },
    {
      label: i18n.t("views.Asset.deviceDetails.transformerSize.label"),
      value: "PowerRating",
      suffix: "kVA",
    },
    {
      label: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
    },

    {
      label: i18n.t("views.Asset.deviceDetails.deviceStatus.label"),
      value: "DeviceStatus",
    },
    {
      label: i18n.t("views.Asset.deviceDetails.deviceVoltage.label"),
      value: "DeviceVoltage",
    },
    {
      label: i18n.t("views.Asset.deviceDetails.installationDate.label"),
      value: "InstallationDate",
      type: "date",
    },
    {
      label: i18n.t("views.Asset.deviceDetails.connectedMPRNs.label"),
      value: "ConnectedMPRNs",
    },
    {
      label: i18n.t("views.Asset.deviceDetails.commuterArea.label"),
      value: "IsCommuterArea",
      icon: "mdi-check-circle-outline",
    },
  ],
  latest_message: [
    {
      label: i18n.t("views.Asset.latestMessage.currentPH1.label"),
      values: ["Current0Med", "Current0Max"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: i18n.t("views.Asset.latestMessage.currentPH1.suffix"),
      helptext: i18n.t("views.Asset.latestMessage.currentPH1.helptext"),
    },
    {
      label: i18n.t("views.Asset.latestMessage.currentPH2.label"),
      values: ["Current1Med", "Current1Max"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: i18n.t("views.Asset.latestMessage.currentPH2.suffix"),
      helptext: i18n.t("views.Asset.latestMessage.currentPH2.helptext"),
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: i18n.t("views.Asset.latestMessage.currentPH3.label"),
      values: ["Current2Med", "Current2Max"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-flash",
      suffix: i18n.t("views.Asset.latestMessage.currentPH3.suffix"),
      helptext: i18n.t("views.Asset.latestMessage.currentPH3.helptext"),
      show: {
        field: "DeviceType",
        value: "ROG3PHASE",
      },
    },
    {
      label: i18n.t("views.Asset.latestMessage.temperature.label"),
      values: ["TemperatureMed", "TemperatureMax"],
      colors: ["vtblue", "primaryDark"],
      icon: "mdi-thermometer",
      suffix: i18n.t("views.Asset.latestMessage.temperature.suffix"),
      helptext: i18n.t("views.Asset.latestMessage.temperature.helptext"),
    },
  ],
  calculated_readings: [
    {
      label: i18n.t("views.Asset.calculatedReadings.totalPower.label"),
      value: "TotalPower",
      suffix: i18n.t("views.Asset.calculatedReadings.totalPower.suffix"),
    },
    {
      label: i18n.t("views.Asset.calculatedReadings.utilization.label"),
      value: "Utilisation",
      suffix: i18n.t("views.Asset.calculatedReadings.utilization.suffix"),
    },
    {
      label: i18n.t("views.Asset.calculatedReadings.imbalance.label"),
      value: "Imbalance",
      suffix: i18n.t("views.Asset.calculatedReadings.imbalance.suffix"),
    },
  ],
  common_fields: {
    //Scv - Net Zero
    DeviceID: "DeviceID",
    AssetID: "AssetID",
    TransformerName: "DeviceName",
    TransformerNo: "SerialNumber",
    CurrentLat: "CurrentLat",
    CurrentLng: "CurrentLng",
    ConnectedMPRNs: "ConnectedMPRNs",
    TransformerRating: "PowerRating",
  },
  devices_table: [
    {
      align: "start",
      text: i18n.t("views.Assets.tables.devices.columns.deviceId.text"),
      value: "DeviceID",
      sortable: true,
      of_type: "modal",
    },
    {
      text: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
      of_type: "modal",
      identifier: "DeviceID",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.monitorType.text"),
      value: "DeviceType",
      of_type: "text",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.deviceName.text"),
      value: "DeviceName",
      of_type: "text",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.powerRating.text"),
      value: "PowerRating",
      of_type: "number",
      suffix: " kVA",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.totalPower.text"),
      value: "TotalPower",
      of_type: "number",
      suffix: " kVA",
      tooltip: i18n.t("views.Assets.tables.devices.columns.totalPower.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.maxCapacity.text"),
      value: "MaxUtilisation",
      of_type: "number",
      suffix: "%",
      tooltip: i18n.t("views.Assets.tables.devices.columns.maxCapacity.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.maxImbalance.text"),
      value: "MaxImbalance",
      of_type: "number",
      round: 2,
      suffix: "%",
      tooltip: i18n.t("views.Assets.tables.devices.columns.maxImbalance.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.current0Max.text"),
      value: "Current0Max",
      of_type: "multi",
      values: ["Current0Max", "Current1Max", "Current2Max"],
      suffix: "A",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.isCommuterArea.text"),
      value: "IsCommuterArea",
      of_type: "switch",
      label: "Commuter",
      icon: "mdi-check-circle-outline",
      color: "primary",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.isWatchlisted.text"),
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.moreActions.text"),
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: [i18n.t("common.labels.editDetails"), i18n.t("common.labels.openAsPage")],
    },
  ],
  messages_table: [
    {
      align: "start",
      text: i18n.t("views.Asset.tables.messages.columns.seqNo.text"),
      value: "UpdatedSeqNo",
      sortable: true,
      of_type: "text",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.messageTime.text"),
      value: "Timestamp",
      of_type: "date",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.missedMessage.text"),
      value: "CountMissing",
      of_type: "text",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.lqi.text"),
      value: "Lqi",
      of_type: "text",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH1.text"),
      value: "Current0Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH1.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH1.text"),
      value: "Current0Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH1.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH2.text"),
      value: "Current1Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH2.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH2.text"),
      value: "Current1Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH2.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH3.text"),
      value: "Current2Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH3.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH3.text"),
      value: "Current2Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH3.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxTemp.text"),
      value: "TemperatureMax",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxTemp.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medTemp.text"),
      value: "TemperatureMed",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medTemp.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.capacity.text"),
      value: "Utilisation",
      of_type: "number",
      round: 2,
      suffix: i18n.t("views.Asset.tables.messages.columns.capacity.suffix"),
      tooltip: i18n.t("views.Asset.tables.messages.columns.capacity.tooltip"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.imbalance.text"),
      value: "Imbalance",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.imbalance.suffix"),
      tooltip: i18n.t("views.Asset.tables.messages.columns.imbalance.tooltip"),
    },
  ],
  devices_table_scv: [
    {
      align: "start",
      text: i18n.t("views.Assets.tables.devices.columns.deviceName.text"),
      value: "DeviceName",
      sortable: true,
      of_type: "modal",
      identifier: "DeviceID",
    },
    {
      text: i18n.t("common.labels.functionalLocation"),
      value: "AssetID",
      of_type: "modal",
      identifier: "DeviceID",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.powerRating.text"),
      value: "PowerRating",
      of_type: "number",
      suffix: " kVA",
      decimal: -1,
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.totalPower.text"),
      value: "TotalPower",
      of_type: "number",
      suffix: " kVA",
      tooltip: i18n.t("views.Assets.tables.devices.columns.totalPower.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.maxCapacity.text"),
      value: "MaxUtilisation",
      of_type: "number",
      suffix: "%",
      tooltip: i18n.t("views.Assets.tables.devices.columns.maxCapacity.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.maxImbalance.text"),
      value: "MaxImbalance",
      of_type: "number",
      suffix: "%",
      tooltip: i18n.t("views.Assets.tables.devices.columns.maxImbalance.tooltip"),
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.current0Max.text"),
      value: "Current0Max",
      of_type: "multi",
      values: ["Current0Max", "Current1Max", "Current2Max"],
      decimal: -1,
      suffix: "A",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.isCommuterArea.text"),
      value: "IsCommuterArea",
      of_type: "switch",
      label: "Commuter",
      icon: "mdi-check-circle-outline",
      color: "primary",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.isWatchlisted.text"),
      value: "IsWatchlisted",
      sortable: false,
      of_type: "add_to_list",
    },
    {
      text: i18n.t("views.Assets.tables.devices.columns.moreActions.text"),
      value: "moreActions",
      sortable: false,
      of_type: "action",
      values: ["EditDetails", "OpenAsAPage"],
      labels: [i18n.t("common.labels.editDetails"), i18n.t("common.labels.openAsPage")],
    },
  ],
  messages_table_scv: [
    {
      align: "start",
      text: i18n.t("views.Asset.tables.messages.columns.seqNo.text"),
      value: "UpdatedSeqNo",
      sortable: true,
      of_type: "text",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.messageTime.text"),
      value: "Timestamp",
      of_type: "date",
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH1.text"),
      value: "Current0Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH1.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH1.text"),
      value: "Current0Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH1.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH2.text"),
      value: "Current1Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH2.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH2.text"),
      value: "Current1Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH2.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.medCurrentPH3.text"),
      value: "Current2Med",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.medCurrentPH3.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH3.text"),
      value: "Current2Max",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.maxCurrentPH3.suffix"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.capacity.text"),
      value: "Utilisation",
      of_type: "text",
      suffix: i18n.t("views.Asset.tables.messages.columns.capacity.suffix"),
      tooltip: i18n.t("views.Asset.tables.messages.columns.capacity.tooltip"),
    },
    {
      text: i18n.t("views.Asset.tables.messages.columns.imbalance.text"),
      value: "Imbalance",
      of_type: "number",
      suffix: i18n.t("views.Asset.tables.messages.columns.imbalance.suffix"),
      tooltip: i18n.t("views.Asset.tables.messages.columns.imbalance.tooltip"),
    },
  ],
  messages_table_snapshot: [
    {
      align: "start",
      text: "Seq No",
      value: "SeqNo",
      of_type: "text",
    },
    {
      text: "Message Time",
      value: "Timestamp",
      of_type: "date",
    },
    {
      text: "Med I1",
      value: "Current0Med",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Max I1",
      value: "Current0Max",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Med I2",
      value: "Current1Med",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Max I2",
      value: "Current1Max",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Med I3",
      value: "Current2Med",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Max I3",
      value: "Current2Max",
      of_type: "text",
      suffix: "A",
    },
    {
      text: "Med Temp.",
      value: "TemperatureMed",
      of_type: "text",
      suffix: "°C",
    },
    {
      text: "Max Temp.",
      value: "TemperatureMax",
      of_type: "text",
      suffix: "°C",
    },
    {
      text: "Missed Msgs",
      value: "CountMissing",
      of_type: "text",
    },
  ],
  maps_config: {
    id: "DeviceID",
    infoText: "DeviceName",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "asset",
    datatype: "powerdata",
  },
  tabs: [
    {
      value: "Charts",
      label: i18n.t("views.Asset.tabs.charts.label"),
    },
    {
      value: "Messages",
      label: i18n.t("views.Asset.tabs.messages.label"),
    },
    {
      value: "EVAnalysis",
      label: i18n.t("views.Asset.tabs.evAnalysis.label"),
    },
    {
      value: "HPAnalysis",
      label: i18n.t("views.Asset.tabs.hpAnalysis.label"),
    },
  ],
  chart_config: [
    {
      id: "temp",
      label: "Temperature (°C)",
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        2: {
          type: "bars",
        },
      },
      xAxis: "TimeStamp",
      yAxis: "Temperature",
      colors: ["#8181a5", "#FF8A80", "#101c49", "#52a0d2", "#f4be5e"],
      areaColors: ["#8181a5", "#101c49", "#FF8A80", "#52a0d2", "#f4be5e"],
    },
    {
      id: "diff",
      label: "Temperature (°C)",
      seriesType: "lines",
      xAxis: "TimeStamp",
      yAxis: "Temperature",
      colors: ["#FF8A80", "#8181a5", "#101c49"],
    },
    {
      id: "imbalance",
      label: "Imbalance and Current Median(A)",
      xAxis: "TimeStamp",
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
          targetAxisIndex: 1,
        },
        4: {
          type: "bars",
          targetAxisIndex: 1,
        },
      },
      yAxis: "Max Load",
      yBarAxis: "Imbalance",
      colors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083"],
    },
    {
      id: "totalPower",
      label: i18n.t("views.Asset.charts.chartConfig1.totalPower.label"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.xAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        4: {
          type: "bars",
        },
      },
      yAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.yBarAxis"),
      colors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083"],
    },
    {
      id: "imbalanceMax",
      label: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.label"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.xAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
          targetAxisIndex: 1,
        },
        4: {
          type: "bars",
          targetAxisIndex: 1,
        },
      },
      yAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.yBarAxis"),
      colors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083"],
    },
    {
      id: "totalPowerMax",
      label: "Total Power and Current Maximum(A)",
      xAxis: "TimeStamp",
      yAxis: "Max Load",
      yBarAxis: "Total Power",
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        4: {
          type: "bars",
        },
      },
      colors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083"],
    },
  ],
  stats_chart: [
    [
      {
        id: "TemperatureMed",
        type: "line",
        label: "Temperature Med",
        suffix: "°C",
      },
      {
        id: "TemperatureMax",
        type: "line",
        label: "Temperature Max",
        suffix: "°C",
      },
    ],
    [
      {
        id: "TemperatureMax",
        type: "line",
        label: "Temperature Max",
        suffix: "°C",
      },
      {
        id: "AmbientTemp",
        type: "line",
        label: "Ambient Temp",
        suffix: "°C",
      },
    ],
    [
      {
        id: "Current0Med",
        type: "line",
        label: "Current PH1 Med",
        suffix: "A",
      },
      {
        id: "Current1Med",
        type: "line",
        label: "Current PH2 Med",
        suffix: "A",
      },
      {
        id: "Current2Med",
        type: "line",
        label: "Current PH3 Med",
        suffix: "A",
      },
      {
        id: "Imbalance",
        type: "bar",
        label: "Imbalance",
        suffix: "%",
      },
    ],
    [
      {
        id: "Current0Med",
        type: "line",
        label: "Current PH1 Med",
        suffix: "A",
      },
      {
        id: "Current1Med",
        type: "line",
        label: "Current PH2 Med",
        suffix: "A",
      },
      {
        id: "Current2Med",
        type: "line",
        label: "Current PH3 Med",
        suffix: "A",
      },
      {
        id: "TotalPower",
        type: "bar",
        label: "Total Power",
        suffix: "kVA",
      },
    ],
    [
      {
        id: "Current0Max",
        type: "line",
        label: "Current PH1 Max",
        suffix: "A",
      },
      {
        id: "Current1Max",
        type: "line",
        label: "Current PH2 Max",
        suffix: "A",
      },
      {
        id: "Current2Max",
        type: "line",
        label: "Current PH3 Max",
        suffix: "A",
      },
      {
        id: "Imbalance",
        type: "bar",
        label: "Imbalance",
        suffix: "%",
      },
    ],
    [
      {
        id: "Current0Max",
        type: "line",
        label: "Current PH1 Max",
        suffix: "A",
      },
      {
        id: "Current1Max",
        type: "line",
        label: "Current PH2 Max",
        suffix: "A",
      },
      {
        id: "Current2Max",
        type: "line",
        label: "Current PH3 Max",
        suffix: "A",
      },
      {
        id: "TotalPower",
        type: "bar",
        label: "Total Power",
        suffix: "kVA",
      },
    ],
  ],
  daily_stats_chart: [
    [
      {
        id: "TemperatureMed",
        type: "line",
        label: "Temperature",
        max: "TemperatureMax",
        min: "TemperatureMin",
      },
    ],
    [],
    [
      {
        id: "Current0Med",
        type: "line",
        label: "Current PH1",
        max: "Current0Max",
        min: "Current0Min",
      },
      {
        id: "Current1Med",
        type: "line",
        label: "Current PH2",
        max: "Current1Max",
        min: "Current1Min",
      },
      {
        id: "Current2Med",
        type: "line",
        label: "Current PH3",
        max: "Current2Max",
        min: "Current2Min",
      },
      {
        id: "ImbalanceMed",
        type: "bar",
        label: "Imbalance",
        max: "ImbalanceMax",
        min: "ImbalanceMin",
      },
    ],
    [
      {
        id: "Current0Med",
        type: "line",
        label: "Current PH1",
        max: "Current0Max",
        min: "Current0Min",
      },
      {
        id: "Current1Med",
        type: "line",
        label: "Current PH2",
        max: "Current1Max",
        min: "Current1Min",
      },
      {
        id: "Current2Med",
        type: "line",
        label: "Current PH3",
        max: "Current2Max",
        min: "Current2Min",
      },
      {
        id: "TotalPowerMed",
        type: "bar",
        label: "Total Power",
        max: "TotalPowerMax",
        min: "TotalPowerMin",
      },
    ],
    [],
    [],
  ],
  chart_config1: [
    {
      id: "temp",
      label: i18n.t("views.Asset.charts.chartConfig1.temp.label"),
      label_daily_stats: i18n.t("views.Asset.charts.chartConfig1.temp.label"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        2: {
          type: "bars",
        },
      },
      xAxis: i18n.t("views.Asset.charts.chartConfig1.temp.xAxis"),
      yAxis: i18n.t("views.Asset.charts.chartConfig1.temp.yAxis"),
      colors: ["#8181a5", "#FF8A80", "#101c49", "#52a0d2", "#f4be5e"],
      areaColors: ["#8181a5", "#101c49", "#FF8A80", "#52a0d2", "#f4be5e"],
    },
    {
      id: "diff",
      label: i18n.t("views.Asset.charts.chartConfig1.diff.label"),
      seriesType: "lines",
      xAxis: i18n.t("views.Asset.charts.chartConfig1.diff.xAxis"),
      yAxis: i18n.t("views.Asset.charts.chartConfig1.diff.yAxis"),
      colors: ["#FF8A80", "#8181a5", "#101c49"],
      areaColors: ["#FF8A80", "#8181a5", "#101c49", "#52a0d2", "#f4be5e"],
    },
    {
      id: "imbalance",
      label: i18n.t("views.Asset.charts.chartConfig1.imbalance.label"),
      label_daily_stats: i18n.t("views.Asset.charts.chartConfig1.imbalance.labelDailyStats"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.imbalance.xAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
          targetAxisIndex: 1,
        },
        4: {
          type: "bars",
          targetAxisIndex: 1,
        },
      },
      yAxis: i18n.t("views.Asset.charts.chartConfig1.imbalance.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.imbalance.yBarAxis"),
      colors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#f4be5e"],
      areaColors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#f4be5e"],
    },
    {
      id: "totalPower",
      label: i18n.t("views.Asset.charts.chartConfig1.totalPower.label"),
      label_daily_stats: i18n.t("views.Asset.charts.chartConfig1.totalPower.labelDailyStats"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.xAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        4: {
          type: "bars",
        },
      },
      yAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.totalPower.yBarAxis"),
      colors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083", "#f4be5e", "#B62C41"],
      areaColors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083", "#f4be5e", "#B62C41"],
    },
    {
      id: "imbalanceMax",
      label: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.label"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.xAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
          targetAxisIndex: 1,
        },
        4: {
          type: "bars",
          targetAxisIndex: 1,
        },
      },
      yAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.imbalanceMax.yBarAxis"),
      colors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#f4be5e"],
      areaColors: ["#002060", "#B62C46", "#52a0d1", "#f08080", "#B62C41", "#52a0d2", "#f08083", "#f4be5e"],
    },
    {
      id: "totalPowerMax",
      label: i18n.t("views.Asset.charts.chartConfig1.totalPowerMax.label"),
      xAxis: i18n.t("views.Asset.charts.chartConfig1.totalPowerMax.xAxis"),
      yAxis: i18n.t("views.Asset.charts.chartConfig1.totalPowerMax.yAxis"),
      yBarAxis: i18n.t("views.Asset.charts.chartConfig1.totalPowerMax.yBarAxis"),
      seriesType: "lines",
      series: {
        0: {
          type: "bars",
        },
        4: {
          type: "bars",
        },
      },
      colors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083", "#f4be5e"],
      areaColors: ["#4D4CAC", "#B62C46", "#52a0d1", "#f08080", "#fe4503", "#52a0d2", "#f08083", "#f4be5e"],
    },
  ],
  params: {
    default: [
      [
        {
          id: "TemperatureMed",
          type: "line",
        },
        {
          id: "TemperatureMax",
          type: "line",
        },
      ],
      [
        {
          id: "Current0Med",
          type: "line",
        },
        {
          id: "Current1Med",
          type: "line",
        },
        {
          id: "Current2Med",
          type: "line",
        },
        {
          id: "Imbalance",
          type: "bar",
        },
      ],
      [
        {
          id: "Current0Med",
          type: "line",
        },
        {
          id: "Current1Med",
          type: "line",
        },
        {
          id: "Current2Med",
          type: "line",
        },
        {
          id: "TotalPower",
          type: "bar",
        },
      ],
      [
        {
          id: "Current0Max",
          type: "line",
        },
        {
          id: "Current1Max",
          type: "line",
        },
        {
          id: "Current2Max",
          type: "line",
        },
        {
          id: "Imbalance",
          type: "bar",
        },
      ],
      [
        {
          id: "Current0Max",
          type: "line",
        },
        {
          id: "Current1Max",
          type: "line",
        },
        {
          id: "Current2Max",
          type: "line",
        },
        {
          id: "TotalPower",
          type: "bar",
        },
      ],
    ],
  },
  chart_select: [
    {
      id: "day",
      label: i18n.t("common.times.time.day"),
      value: 1,
      stringValue: "Day",
    },
    {
      id: "week",
      label: i18n.t("common.times.time.lastWeek"),
      value: 7,
      stringValue: "Week",
    },
    {
      id: "3month",
      label: i18n.t("common.times.time.last3Months"),
      value: 90,
      stringValue: "3 Months",
    },
    {
      id: "6month",
      label: i18n.t("common.times.time.last6Months"),
      value: 182,
      stringValue: "6 Months",
    },
    {
      id: "1year",
      label: i18n.t("common.times.time.last1Year"),
      value: 365,
      stringValue: "DYearay",
    },
  ],
  health_chart: {
    id: "life_lost_chart",
    type: "line",
    label: "RMS Voltage (V)",
    xAxis: "Month",
    yAxis: "FEQA",
    zAxis: "Usage",
    colors: ["#5e81f4", "#f0f0f3", "#B62C46"],
    strokeWidth: 2,
    min: 0,
    max: 1,
  },
  life_lost_stats: [
    {
      label: "Last Month At Glance",
      value: "Month",
      icon: "mdi-map-marker-circle",
      color: "primaryOutline",
      type: "string",
    },
    {
      label: "Usage",
      value: "Usage",
      icon: "mdi-clock-outline",
      color: "primary",
      type: "hours",
      tooltip: "Number of hours in the month for which data is available",
    },
    {
      label: "FEQA",
      value: "Feqa",
      icon: "mdi-chart-line-variant",
      color: "secondary",
      type: "percent",
      tooltip: "FEQA = Hours Lost / Usage",
    },
    {
      label: "Hours Lost",
      value: "LifeLost_in_hrs",
      icon: "device_hub",
      color: "success",
      type: "number",
    },
    {
      label: " % Life Lost",
      value: "Per_lossoflife",
      icon: "device_hub",
      color: "success",
      type: "percent",
      tooltip: "180k hours overall life",
    },
  ],
};

export { content };
